import axios from 'axios';
import { TimeSlotModel } from 'src/models/customer/timeSlotModel';
import { API_url } from 'src/services/api.setup';

const API_Controller = '/TimeSlot';
const cartType = 1;

export const TimeSlotServicess = {
  getData: async () => {
    try {
      const response = await axios.get(
        `${API_url}${API_Controller}/getalltimeslotincludingisbackend`
      );
      return response.data as TimeSlotModel[];
    } catch (error) {
      throw error;
    }
  },

  getDataById: async (id) => {
    try {
      const response = await axios.get(
        `${API_url}${API_Controller}/get?id=${id}`
      );
      return response.data as TimeSlotModel; 
    } catch (error) {
      throw error
    }
  }

 
};
